import { CircleCheck, Info, OctagonAlert, TriangleAlert } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const TagType = {
    INFORMATION: 'information',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DISABLED: 'disabled',
    UTILITY_ROSE: 'utility-rose',
    UTILITY_GREEN: 'utility-green',
} as const;

type TagTypeValue = typeof TagType[keyof typeof TagType];

interface TagProps {
    type: TagTypeValue;
    message: string;
}

interface TagImgProps {
    type: TagTypeValue;
}

const TagImg = ({type}: TagImgProps) => {
    switch (type) {
        case TagType.INFORMATION:
            return <Info size={ICON_SIZE.SMALL} className="ga-tag__icon" />;
        case TagType.SUCCESS:
            return <CircleCheck size={ICON_SIZE.SMALL} className="ga-tag__icon" />;
        case TagType.WARNING:
            return <TriangleAlert size={ICON_SIZE.SMALL} className="ga-tag__icon" />;
        case TagType.ERROR:
            return <OctagonAlert size={ICON_SIZE.SMALL} className="ga-tag__icon" />;
        case TagType.DISABLED:
        case TagType.UTILITY_ROSE:
        case TagType.UTILITY_GREEN:
        default:
            return null;
    }
}

export const Tag = ({ type, message }: TagProps) => {
    return (
        // A span (ga-tag sets its own inline-flex display), so a tag can also sit inside a button
        <span className={`ga-tag ga-tag--${type}`}>
            {type &&
                <TagImg type={type} />
            }
            <span className= "ga-tag__label white-space-unset">{message}</span>
        </span>
    );
}